export default function customerOverview(state = {}, action) {
  switch (action.type) {
    case "SET_RUNNING_JOBS_AND_DEVICE_HEALTH":
      const { runningJobs, systemHealth } = action
      return { runningJobs, systemHealth }
    default:
      return state
  }
}
